export default class TableOfContent{
	constructor() {

		this.toc = document.querySelector('[data-nav]');

        if (!this.toc) {
            return;
        }

        this.makeMenu()

        this.navLinks = this.toc.querySelectorAll('.m-toc__nav-link');

        this.navLinks.forEach(el => {

            el.addEventListener('click', () => {
                setTimeout(() => {
                    window.scrollTo(window.scrollX, window.scrollY - 50);
                }, 10);
            });
        })

        window.addEventListener('scroll', () => {
            this.checkScrollPosition();
        });

        this.checkScrollPosition();
	}

    makeMenu() {
        this.sectionItems = document.querySelectorAll('[data-navitem]');

        this.sectionItems.forEach(item => {

            const li = document.createElement('li');
            const name = item.dataset.navitem;

            li.innerHTML = `<a class="m-toc__nav-link" href="#${item.id}">${name}</a>`;

            this.toc.appendChild(li);
        });

    }


    checkScrollPosition() {
        let scrollPosition = window.scrollY + 80;

        this.sectionItems.forEach(section => {

            if (scrollPosition >= section.offsetTop) {
                this.navLinks.forEach(link => {
                    link.parentElement.classList.remove('is-active');

                    if (section.getAttribute('id') === link.getAttribute('href').substring(1)) {
                        link.parentElement.classList.add('is-active');
                    }
                });
            }
        });
    }
}

